/** Desktop sidebar is visible at this width and above. */
export const SIDEBAR_DESKTOP_MIN_WIDTH_PX = 1280;

/** Mobile drawer / hide persistent sidebar below desktop. */
export const SIDEBAR_MOBILE_MAX_WIDTH_PX = SIDEBAR_DESKTOP_MIN_WIDTH_PX - 1;

export const SIDEBAR_DESKTOP_MIN_WIDTH = `${SIDEBAR_DESKTOP_MIN_WIDTH_PX}px`;
export const SIDEBAR_MOBILE_MAX_WIDTH = `${SIDEBAR_MOBILE_MAX_WIDTH_PX}px`;

export const MOBILE_SIDEBAR_OVERLAY_Z_INDEX = 1200;

export const mobileSidebarMediaQuery = `(max-width: ${SIDEBAR_MOBILE_MAX_WIDTH})`;
export const desktopSidebarMediaQuery = `(min-width: ${SIDEBAR_DESKTOP_MIN_WIDTH})`;
